import * as React from "react";
import { AppBar, TitlePortal, ToggleThemeButton, useLogout } from "react-admin";
import { Box, Button, Tooltip } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import logoComfort from "../assets/logo-comfort.png";
import logoLolia from "../assets/logo-lolia.png";

export default function CustomAppBar(props) {
  const logout = useLogout();

  const handleLogout = () => {
    logout();
  };

  return (
    <AppBar
      {...props}
      color="primary"
      elevation={1}
      sx={{
        background: "#fdffffff",
        color: "#111",
        borderBottom: "1px solid #e5e7eb",
        minHeight: 60,
        display: "flex",
        justifyContent: "center",
      }}
      userMenu={false}
    >
      {/* LEFT SIDE — Both Logos */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          ml: 2,
        }}
      >
        <img src={logoComfort} alt="Comfort Line Logo" style={{ height: 36 }} />

        <Box sx={{ width: "1px", height: 30, background: "#ddd", mx: 1 }} />

        <img src={logoLolia} alt="Lolia Limousine Logo" style={{ height: 36 }} />
      </Box>

      {/* CENTER TITLE — ⭐ FIXED: remove nested <Typography variant="h6"> */}
      <TitlePortal>
        <span
          style={{
            fontWeight: 700,
            color: "#0f172a",
            marginLeft: "8px",
            fontSize: "1.05rem",
          }}
        >
          Comfort Line & Lolia Dashboard
        </span>
      </TitlePortal>

      {/* RIGHT SIDE BUTTONS */}
      <Box sx={{ ml: "auto", mr: 2, display: "flex", alignItems: "center", gap: 1 }}>
        <ToggleThemeButton />
        <Tooltip title="Log out and switch user">
          <Button
            type="button"
            onClick={handleLogout}
            startIcon={<LogoutIcon />}
            variant="outlined"
            size="small"
            sx={{
              textTransform: "none",
              fontWeight: 700,
              borderRadius: 2,
              whiteSpace: "nowrap",
            }}
          >
            Logout
          </Button>
        </Tooltip>
      </Box>
    </AppBar>
  );
}
